import { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { useSelector } from "react-redux";
import PublicRoutes from "./routes/PublicRoutes";
import PrivateRoutes from "./routes/PrivateRoutes";
import { selectUserInformations } from "./features/authSlice";
import Redirect from "./pages/Redirect";
import "./assets/css/scrollbar.css";
import LandingMain from "./pages/Landing/LandingMain";
import AllCoursesPage from "./pages/Landing/AllCoursesPage";
import PublicPlacementTestsPage from "./pages/PlacementTest/PublicPlacementTestsPage";
import PublicPlacementTestDetailsPage from "./pages/PlacementTest/PublicPlacementTestDetailsPage";
import PlacementTestEnrollmentPage from "./pages/PlacementTest/PlacementTestEnrollmentPage";
import PlacementTestLinkRedirectPage from "./pages/PlacementTest/PlacementTestLinkRedirectPage";

function App() {
  const user = useSelector(selectUserInformations);

  useEffect(() => {
    let scrollTimeout;
    const htmlElement = document.documentElement;
    let isScrolling = false;

    const handleScroll = () => {
      if (!isScrolling) {
        htmlElement.classList.add("scrolling");
        isScrolling = true;
      }

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        htmlElement.classList.remove("scrolling");
        isScrolling = false;
      }, 1000);
    };

    // Add event listeners
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<LandingMain />} />
      <Route path="/courses" element={<AllCoursesPage />} />
      <Route path="/placement-tests" element={<PublicPlacementTestsPage />} />
      <Route path="/placement-tests/:id" element={<PublicPlacementTestDetailsPage />} />
      <Route path="/placement-tests/:id/payment" element={<PlacementTestEnrollmentPage />} />
      <Route path="/placement-test/link/:uuid" element={<PlacementTestLinkRedirectPage />} />

      {/* Public Routes */}
      {!user && <Route path="/*" element={<PublicRoutes />} />}

      {/* Private Routes */}
      {user && <Route path="/*" element={<PrivateRoutes />} />}

      <Route path="/redirect" element={<Redirect />} />

      {/* Catch-All Redirect */}
      <Route
        path="*"
        element={<Navigate to={user ? "/dashboard" : "/login"} />}
      />
    </Routes>
  );
}

export default App;
